/**
 *
 * ParrotSoftware
 * GoogleMapsProvider constants
 *
 */
export const GEOCODING_LOOKUP_LATITUDE_LONGITUDE =
  'providers/onlineOrdering/GoogleMapsProvider/GEOCODING_LOOKUP_LATITUDE_LONGITUDE';
